/**
 * The fixed 48x32 numeric identifier chip that aligns location codes down a
 * column. Per the Figma component note it carries NO state — it is not a status
 * badge.
 *
 * Lifted out of `StocktakeSetupScreen` and `StocktakeLocationDetailScreen`,
 * which each had a byte-identical copy.
 */
function LocationChip({ code }: Readonly<{ code: string }>) {
  return (
    <div className="flex h-8 w-12 shrink-0 items-center justify-center rounded-full bg-accent">
      <span className="text-sm font-bold text-foreground">{code}</span>
    </div>
  )
}

export { LocationChip }
